var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('yd-navbar',{attrs:{"slot":"navbar","title":_vm.title},slot:"navbar"},[_c('div',{attrs:{"slot":"left"},on:{"click":_vm.back},slot:"left"},[_c('yd-navbar-back-icon')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-59a66981","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/NavBar.vue
// module id = null
// module chunks = 